import React, { ReactElement } from "react"
import { Col, Row } from "reactstrap"
import { SemiBoldText } from "../WireTransfers.styled"
import { DetailText, HeaderLineContainer } from "./DetailLine.styled"

export const DetailLineHeader = (): ReactElement => {
  return (
    <HeaderLineContainer>
      <Row>
        <Col md={2}>
          <DetailText>
            <SemiBoldText>Keeper</SemiBoldText>
          </DetailText>
        </Col>
        <Col md={2}>
          <DetailText>
            <SemiBoldText>Titulaire du compte</SemiBoldText>
          </DetailText>
        </Col>
        <Col md={1}>
          <DetailText>
            <SemiBoldText>Montant</SemiBoldText>
          </DetailText>
        </Col>
        <Col md={2}>
          <DetailText>
            <SemiBoldText>IBAN</SemiBoldText>
          </DetailText>
        </Col>
        <Col md={1}>
          <DetailText>
            <SemiBoldText>BIC</SemiBoldText>
          </DetailText>
        </Col>
        <Col md={2} />
      </Row>
    </HeaderLineContainer>
  )
}
